<nz-row nzGutter="24">
  <nz-col [nzSm]="24">
    <input
      nz-input
      [name]="config.name"
      [placeholder]="config.placeholder"
      [(ngModel)]="config.value"
      (ngModelChange)="onChange($event)"
      [required]="config.required"
    />
  </nz-col>
  <nz-col [nzSm]="24" *ngIf="config.effective.length">
    <app-effective-display [config]="config"> </app-effective-display>
  </nz-col>
</nz-row>
